// dependencies
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// selectors
import { getCurrentEnvironment } from "Selectors/app";

import css from "./Avatar";

class Avatar extends React.PureComponent {
	static propTypes = {
		size: PropTypes.number,
		className: PropTypes.string,
		userID: PropTypes.string.isRequired,
		environment: PropTypes.object.isRequired,
	};

	static defaultProps = {
		className: "",
		size: 100,
	};

	render = () => {
		const { userID, size, className, environment } = this.props;
		return (
			<img
				alt={userID}
				className={`${css.Avatar} ${className}`}
				height={size}
				width={size}
				src={`${environment.cdn}/avatar/${userID}/`}
			/>
		);
	};
}

const mapStateToProps = (state) => ({
	environment: getCurrentEnvironment(state),
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Avatar);
